import React, { Fragment } from 'react'
import store from '../store'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Input, Switch, Tooltip } from 'hljd'

export default [
  {
    title: '排序',
    dataIndex: 'index',
    key: 'index',
    render: (text, record, index) => index + 1
  },
  {
    title: '封面图',
    dataIndex: 'cover_path',
    key: 'cover_path',
    render: cover_path => (
      <div>
        {cover_path ? (
          <img
            src={
              cover_path.indexOf('?imageMogr2') > -1
                ? cover_path + '/thumbnail/!120'
                : cover_path + '?imageView2/1/w/120'
            }
          />
        ) : (
          '暂无'
        )}
      </div>
    )
  },
  {
    title: '分类名',
    dataIndex: 'title',
    key: 'title',
    render: (text, record) => <div>{record.title ? record.title : '-'}</div>
  },
  {
    title: '案例数量',
    dataIndex: 'item_count',
    key: 'item_count'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (text, record) => <div>{record.created_at}</div>
  },
  {
    title: '是否有效',
    dataIndex: 'is_show',
    key: 'is_show',
    render: (text, record, index) => {
      return (
        <Switch
          checkedChildren="是"
          unCheckedChildren="否"
          checked={Boolean(Number(record.is_show))}
          onChange={store.handleSwitchChange.bind(this, index)}
        />
      )
    }
  },
  {
    title: () => (
      <Tooltip title="权重越大，排序越靠前">
        <span>排序权重</span>
        <QuestionCircleOutlined style={{ color: '#ffbf00', marginLeft: 5 }} />
      </Tooltip>
    ),
    dataIndex: 'weight',
    key: 'weight',
    render: (text, record, index) => (
      <Input
        value={record.weight ? record.weight : '-'}
        onChange={store.changeField('weight', index)}
        onBlur={store.editCategory(record, text)}
        onFocus={store.saveCategory(record)}
        style={{ width: '100px' }}
      />
    )
  },
  {
    title: '操作',
    dataIndex: 'edit',
    key: 'edit',
    render: (text, record) => (
      <Fragment>
        <p>
          <a
            style={{ color: '#508cee' }}
            onClick={store.showModal(
              record.id,
              record.title,
              record.weight,
              record.cover_path
            )}
          >
            编辑
          </a>
        </p>
        <p>
          <a
            style={{ color: '#ff5c5c' }}
            onClick={store.comfirmDel(record.id, 1)}
          >
            删除
          </a>
        </p>
      </Fragment>
    )
  }
]
